import { useEffect, useState } from 'react';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { adapter4BackendProxy } from '../../Utils/utilsDashboards';
import CandidaturesParAo from './Dashbords/CandidaturesParAo';
import StatutCandidatures from './Dashbords/StatutCandidatures';
import TotalAo from './Dashbords/TotalAo';

const AoCandidatures = () => {
    const axiosPrivate = useAxiosPrivate();
    const [DataForCandidatureRecuParAO, SetDataForCandidatureRecuParAO] = useState();
    const {device}=useWindowSize();
    //const [dataAllAos, SetDataAllAos]=useState();

    //const [selectedStatutPaiementCaffaireCR, setSelectedStatutPaiementCaffaireCR] = useState('all'); // Default selected period
    const [selectedClient, setSelectedClient] = useState([]); // Default selected Client

    const [statusCandiaturesByCompanyId,setAllStatusCandiaturesByCompanyId]= useState();
    //const [allStatusMissions,setAllStatusMissions]= useState();
    //const [allCras,setAllCras]= useState();
    //const [allFactures,setAllFactures]=useState();
    //const [selectedBackOffice,setSelectedBackOffice]=useState('all');

    useEffect(() =>{
        getDataForCandidatureRecuParAO();
    }, []);
    const { setBackdropOpen} = useUtilities();
    const getDataForCandidatureRecuParAO = async () => {
        try {
            // const response1 = await fetch(API_URI_CVTheque + 'getStatistics/'+ encodeURIComponent(temp), {
            //     method: 'Get',
            // });
            setBackdropOpen(true);
            //const [allCandidatures,totalAos,allStatusCandiatures, allMissions,cras,factures,chiffreAffaire,trafics] = await adapter4BackendProxy(axiosPrivate,  'getStatistics/None');
            //const allStatusCandiatures = await adapter4BackendProxy(axiosPrivate, 'admin/getStatusCandidatures');
            //const allCandidatures=await adapter4BackendProxy(axiosPrivate, 'admin/getTotalCandidatures');

            const [
                allStatusCandiatures,
                allCandidatures,
            ] = await Promise.all([
                adapter4BackendProxy(axiosPrivate, 'admin/getStatusCandidatures'),
                adapter4BackendProxy(axiosPrivate, 'admin/getTotalCandidatures'),
            ]);

            //const rdvs=await adapter4BackendProxy(axiosPrivate, '/admin/admin/getRdvs');
            //const allMissions=await adapter4BackendProxy(axiosPrivate, '/admin/getMissions');
            //const cras=await adapter4BackendProxy(axiosPrivate, '/admin/getCrasX');
            //const chiffreAffaire=await adapter4BackendProxy(axiosPrivate, '/admin/getCA');

            SetDataForCandidatureRecuParAO(allCandidatures);
            setAllStatusCandiaturesByCompanyId(allStatusCandiatures);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    useEffect(()=>{
        getAllClient();
    },[]);

    const getAllClient = async () => {
        try {
            // const response2 = await fetch(API_URI_CVTheque + 'getAllListClient', {
            //     method: 'Get',
            // });
            const clientList = await adapter4BackendProxy(axiosPrivate,   'getAllListClient');
            clientList.push({_id: 'all',value:'all', label: 'Tous les clients'});
            console.log(Array.isArray(clientList));
            setSelectedClient(clientList);
        } catch (error) {
            console.log(error.response?.status);
        }
    };
    return (
        <>
            <CandidaturesParAo
                DataForCandidatureRecuParAO={DataForCandidatureRecuParAO}
                filtreClient={true}
                width={'100%'}
                height={device=='desktop'?'365px':'auto'}
            />
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',alignSelf:'stretch'}}>
                <TotalAo
                    selectedClient={selectedClient}
                    dataAllAos={DataForCandidatureRecuParAO}
                    filtreClient={true}
                    width={device=='desktop'?'60%':'100%'}
                    height={device=='desktop'?'365px':'auto'}
                />

                <StatutCandidatures
                    statusCandiaturesByCompanyId={statusCandiaturesByCompanyId}
                    filtreClient={true}
                    width={device=='desktop'?'40%':'100%'}
                    height={device=='desktop'?'365px':'auto'}
                />
            </div>

            {/*<StatutMissions
                allStatusMissions={allStatusMissions}
                selectedClient={selectedClient}
                filtreClient={true}
                width={'100%'}
                height={'365px'}
            />
            <div style={{display:'flex',flexDirection:'row',gap:'24px',width:'100%',alignSelf:'stretch'}}>
                <StatutCras
                    allCras={allCras}
                    filtreClient={true}
                    width={'50%'}
                    height={'365px'}
                />

                <StatutFactures
                    allFactures={allFactures}
                    filtreClient={true}
                    width={'50%'}
                    height={'365px'}
                />
            </div>*/}

        </>
    );
};
export default AoCandidatures;